import { useUiStore } from "src/components/main/uiStore";
// handle "/" in file name
import { useState } from "react";
import { LoaderFunctionArgs, useLoaderData, useParams, useRevalidator } from "react-router-dom";
import { saveAs } from "file-saver";
// import axios from "axios";
//-------------------------------------------------
import FileIcon from "src/components/common/fileIcons";
import Footer from "src/components/common/frame/footer";
import { useUploadStore } from "src/components/main/uploadStore";
import {
    myAxios,  
    scroll, 
    getFileNameFromUrl
} from "src/components/common/functions";
import Modal from "../common/Modal";
import { Link } from "react-router-dom";
export const invalidFileNameChars = ["\\" /* only this not allowed in linux */, "/", ":", "*", "?", "\"", "<", "<", "|"];
export const defaultFolder = "";
export const defaultFolders = [
    {label: "Construct Smarter", value: ""}, 
]
export const paramlists = {
    "path": [], 
    "searchBar": ["true"],
    "matchCase": ["true"],
    "matchWholeWold": ["true"],
    "showReplaceBar": ["true"],
    "searchQuery": [],
    "replaceQuery": [],
};
type parents = {id: string, name: string}[];
type files = {id: string, name: string, type: string}[];
type fileInfo  = {id?: string, name?: string, type?: string};
//-------------------------------------------------
    export default function FileExplorer(){
    const revalidator = useRevalidator();
    const upload = useUploadStore();
    const parentId = useParams().id;
    const setShowLoader = useUiStore(state => state.setShowLoader);
    //-------------------------------------------------
    const { parents, files }:{parents:parents,files:files} = useLoaderData();
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [filterWords, setFilterWords] = useState("");
    //-------------------------------------------------
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const filteredData = files.filter(item => filterWords === ""?true:JSON.stringify(item).toLowerCase().includes(filterWords));
    const currentPageItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const [showFileInfo, setShowFileInfo] = useState(false);
    const [fileInfo, setFileInfo] = useState<fileInfo>({});
    //-------------------------------------------------
    return (
        <div className = "cssContent pb8rem">
            <nav className = "d-flex align-items-center mt-2 mb-4">
                <span className = "d-inline-flex align-items-center me-3">
                    <label
                        children = "Search:"
                        htmlFor = "search"
                        className = "me-2"
                    />
                    <input
                        id = "search"
                        className = "form-control inline w-auto"
                        type = "text"
                        value = {filterWords}
                        onChange = {e => {
                            setFilterWords(e.currentTarget.value.toLowerCase());
                        }}
                    />
                </span>
                <span className = "d-inline-flex align-items-center me-3">
                    <label className = "btn btn-primary mb-0" htmlFor = "file">
                        Upload Files
                        <input
                            id = "file"
                            type = "file"
                            multiple = {true}
                            className = "nodisplay"
                            onChange = {async e => {
                                const target = e.currentTarget;
                                const files = target.files;
                                if(!files || files.length === 0 || files[0].name === "") return;
                                const formData = new FormData();
                                formData.append("action", "uploadFiles");
                                if(parentId) formData.append("parentId", parentId);
                                for(const file of files){
                                    formData.append("fileName[]", file.name);
                                    formData.append("fileSize[]", String(file.size));
                                    formData.append("fileType[]", file.type);
                                    formData.append("lastModifiedAt[]", (new Date(file.lastModified)).toISOString().slice(0, 19).replace('T', ' '));
                                    //------------------------
                                }
                                setShowLoader(true);
                                const preRes = await myAxios({ fileName: "server/fileStorage.php", formData: formData });
                                setShowLoader(false);
                                if(!preRes) return;
                                upload.setFiles(Array.from(files));
                                upload.setUrls(preRes.data.urls);
                                upload.setIds(preRes.data.ids);
                                upload.setShow(true);
                                upload.setOnResetCallback(() => {
                                    revalidator.revalidate();
                                });
                                target.value = "";
                            }}
                        />
                    </label>
                </span>
                <span className = "d-inline-flex align-items-center me-3">
                    <button
                        children = "Add Folder"
                        type = "button"
                        className = "btn btn-primary"
                        onClick = {async() => {
                            const userInput = window.prompt("The new folder name:");
                            if(userInput === null || userInput === "") return;
                            for(let char of invalidFileNameChars){
                                if(userInput.indexOf(char) > -1){
                                    if(char === "\"") window.alert(`${char} is not allowed for folder name.`);
                                    else window.alert(`"${char}" is not allowed for folder name.`);
                                    return;
                                }
                            }
                            const formData = new FormData();
                            formData.append("action", "createFolder");
                            if(parentId) formData.append("parentId", parentId);
                            formData.append("folderName", userInput);
                            const res = await myAxios({ fileName: "server/fileStorage.php", formData: formData })
                            if(!res) return;
                            revalidator.revalidate();
                        }}
                    />
                </span>
            </nav>
            {<>
                <div className = "h4 my-3">
                    {parentId ? 
                    <Link
                        children = {<span
                            children = "/Base"
                            className = {parentId === ""?"":"pointer text-decoration-underline"}
                        />}
                        className = "text-success"
                        to = "/FileStorage"
                        onClick = {() => {
                            scroll(null);
                            setCurrentPage(1);

                        }}
                    />
                    :
                    <span
                        children = "/Base"
                    />
                    }
                    {parents.length ? parents.map((parent, parentIndex) => 
                    parentId !== parent.id?
                    <Link
                        key = {parentIndex}
                        children = {<span
                            children = {`/${parent.name}`}
                            className = "pointer text-decoration-underline"
                        />}
                        className = "text-success"
                        to = {String(parent.id)}
                        onClick = {() => {
                            scroll(null);
                            setCurrentPage(1);
                        }}
                    />
                    :
                    <span
                        key = {parentIndex}
                        children = {`/${parent.name}`}
                    />
                    )
                    :null}
                </div>
                {!filteredData.length?<div className = "cssLoading">Empty</div>:
                currentPageItems.map((item, index) => 
                <div key = {index} className = "h5">
                    {item.type === "folder"?
                    <Link
                        className = "pointer text-primary"
                        children = {<>
                            <FileIcon
                                fileType = {item.name.split(".").at(-1) ?? ""} 
                                isFolder = {true} 
                                className = "me-2"
                            />
                            {item.name}
                        </>}
                        to = {String(item.id)}
                        onClick = {() => {
                            scroll(null);
                            setCurrentPage(1);
                        }}
                    />
                    :
                    <span
                        children = {item.name}
                    />
                    }
                    <button
                        children = "rename"
                        type = "button"
                        className = "ms-2 btn btn-warning"
                        onClick = {async() => {
                            if(!window.confirm("Are you sure to rename this " + (item.type === "folder"?"folder":"file") + "?")) return;
                            const userInput = window.prompt(item.name + "\nupdated " + (item.type === "folder"?"folder":"file") + " name:", item.name);
                            if(userInput === null || userInput === "" || userInput === item.name) return;
                            const formData = new FormData();
                            formData.append("action", "rename");
                            formData.append("fileId", item.id);
                            formData.append("newFileName", userInput);
                            //------------------------
                            setShowLoader(true);
                            const res = await myAxios({ fileName: "server/fileStorage.php", formData: formData });
                            setShowLoader(false);
                            if(!res) return;
                            //------------------------
                            revalidator.revalidate();
                        }}
                    />
                    <button
                        children = "move"
                        type = "button"
                        className = "ms-2 btn btn-warning"
                        onClick = {async() => {
                            if(!window.confirm("Are you sure to move this " + (item.type === "folder"?"folder":"file") + "?")) return;
                            const userInput = window.prompt(item.name + "\nupdated " + (item.type === "folder"?"folder":"file") + " parentId:");
                            if(userInput === null || userInput === "") return;
                            const formData = new FormData();
                            formData.append("action", "move");
                            formData.append("fileId", item.id);
                            formData.append("newParentId", userInput);
                            //------------------------
                            setShowLoader(true);
                            const res = await myAxios({ fileName: "server/fileStorage.php", formData: formData });
                            setShowLoader(false);
                            if(!res) return;
                            //------------------------
                            revalidator.revalidate();
                        }}
                    />
                    {item.type !== "folder"?
                    <button
                        children = "download"
                        type = "button"
                        className = "ms-2 btn btn-info"
                        onClick = {async() => {
                            const formData = new FormData();
                            formData.append("action", "downloadFile");
                            formData.append("fileId", item.id);
                            formData.append("fileName", item.name);
                            //------------------------
                            setShowLoader(true);
                            const preRes = await myAxios({ fileName: "server/fileStorage.php", formData: formData });
                            setShowLoader(false);
                            if(!preRes) return;
                            const url = preRes.data;
                            try{
                                const response = await fetch(url);
                                if(!response.ok) throw new Error("Failed to fetch file");
                                saveAs(await response.blob(), getFileNameFromUrl(url)!);
                            }catch(error){
                                window.alert("Error downloading file:" + error);
                            }
                        }}
                    />
                    :null}
                    <button
                        children = "property"
                        type = "button"
                        className = "ms-2 btn btn-info"
                        onClick = {() => {
                            setShowFileInfo(true);
                            setFileInfo(item);
                        }}
                    />
                    <button
                        children = "delete"
                        type = "button"
                        className = "ms-2 btn btn-danger"
                        onClick = {async() => {
                            if(!window.confirm("Are you sure to delete this " + (item.type === "folder"?"folder (recursively delete all files and folders within the folder)":"file") + "?")) return;
                            const formData = new FormData();
                            formData.append("action", item.type === "folder"?"deleteFolder":"deleteFile");
                            formData.append("fileId", item.id);
                            //------------------------
                            setShowLoader(true);
                            const res = await myAxios({ fileName: "server/fileStorage.php", formData: formData });
                            setShowLoader(false);
                            if(!res) return;
                            //------------------------
                            revalidator.revalidate();
                        }}
                    />
                </div>)}
            </>}
            {filteredData.length?
            <Footer
                length = {filteredData.length}
                currentPage = {currentPage}
                setCurrentPage = {setCurrentPage}
                itemsPerPage = {itemsPerPage}
                setItemsPerPage = {setItemsPerPage}
            />
            :null}
            {showFileInfo?
            <Modal
                touchOutsideClose = {true}
                closeIt = {() => setShowFileInfo(false)}
                title = "File Information"
                width = {1000} maxWidth = {"100%"}
            >
                <p></p>
                {Object.entries(fileInfo).filter(entry => entry[1]).map(([key, value]) => 
                <p key = {key}>
                    <label className = "inline h5">{key}:</label>
                    <span className = "ms-3">{value}</span>
                </p>)}
            </Modal>:null}
        </div>
    )
}

export async function fileStorageLoader({ params }: LoaderFunctionArgs) {
    const parentId = params.id;
    const formData = new FormData();
    formData.append("action", "readFolder");
    if (parentId) formData.append("parentId", parentId);
    const res = await myAxios({
        fileName: "server/fileStorage.php",
        formData,
    });
    if (!res) return;
    return {
        files: res.data.files,
        parents: res.data.parents.reverse(),
    };
}
